<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Дашбоард"> </main-header>
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="row row-xs">
          <div class="col-lg-4">
            <vehicle-count></vehicle-count>
          </div>
          <div class="col-lg-4">
            <terminals bd="" mgt=""></terminals>
          </div>
          <div class="col-lg-4">
            <accident bd="" mgt=""></accident>
          </div>
        </div>

        <map-asset></map-asset>
      </div>
    </div>
    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>
    <filter-date @do-search="doSearch2" :mdl="filterDateObj2.mdl" @on-hide="filterDateObj2.mdl= false"></filter-date>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
//import mapAsset from "@/views/apps/penalty/components/mapAsset.vue";

const moment = require("moment");
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Switch } from "element-ui";

export default {
  components: {
    apexchart: VueApexCharts,
    Switch,
    DatePicker,
    //mapAsset,
    filterDate: () => ({
      component: import("@/views/apps/zgpenalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    mainHeader: () => ({
      component: import("@/views/apps/zgpenalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    penaltyGroupByType: () => ({
      component: import(
        "@/views/apps/zgpenalty/components/penaltyGroupByType.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    penaltyPaidData: () => ({
      component: import("@/views/apps/zgpenalty/components/penaltyPaidData.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mapAsset: () => ({
      component: import("@/views/apps/zgpenalty/components/mapAsset.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    terminals: () => ({
      component: import("@/views/apps/zgpenalty/components/terminals.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accident: () => ({
      component: import("@/views/apps/zgpenalty/components/accident.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    vehicleCount: () => ({
      component: import("@/views/apps/zgpenalty/components/vehicleCount.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },
      filterDateObj2: {
        mdl: false,
        d1: null,
        d2: null
      },

      chartDaysOptionsKey: 0,
      chartDaysOptionsKey2: 0,
      seriesDays: [
        {
          name: "%",
          data: [],
        },
      ],

      seriesDays2: [
        {
          name: "%",
          data: [],
        },
      ],
      chartDaysOptions: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      chartDaysOptions2: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      mapDate: null,
      restrictedDaysData: {
        rdy: false,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          distinct: false,
        },
        data: {
          list: [],
        },
      },
      tovchoods: [],
      colors: ["green", "primary", "orange"],

      restrictedDaysData2: {
        rdy: false,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          distinct: false,
        },
        data: {
          list: [],
        },
      },
    };
  },
  mounted() {
    this.loadHyazgaarlalt();
    this.loadHyazgaarlalt2();
    this.loadTovchood();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    //
    doSearch(e){
      this.restrictedDaysData.params.startDate= e.d1;
      this.restrictedDaysData.params.endDate= e.d2;
      this.restrictedDaysData.params.mode= 0;
      this.loadHyazgaarlalt();
    },

    doSearch2(e){
      this.restrictedDaysData2.params.startDate= e.d1;
      this.restrictedDaysData2.params.endDate= e.d2;
      this.restrictedDaysData2.params.mode= 0;
      this.loadHyazgaarlalt2();
    },
    loadHyazgaarlalt() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhLimitedPlateNo" },
        params: {
          mode: this.restrictedDaysData.params.mode,
          startDate: this.restrictedDaysData.params.startDate,
          endDate: this.restrictedDaysData.params.endDate,
          distinct: this.restrictedDaysData.params.distinct,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.restrictedDaysData.data = res.data;
          this.seriesDays[0].data = res.data.list.map((x) => {
            return x.count;
          });
          this.chartDaysOptions.xaxis.categories = res.data.list.map((x) => {
            return x.dayText;
          });
          this.chartDaysOptionsKey++;
          this.restrictedDaysData.rdy = true;
        }
      });
    },

    loadHyazgaarlalt2() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/PenaltyByAchilt" },
        params: {
          mode: this.restrictedDaysData2.params.mode,
          startDate: this.restrictedDaysData2.params.startDate,
          endDate: this.restrictedDaysData2.params.endDate,
          distinct: this.restrictedDaysData2.params.distinct,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.restrictedDaysData2.data = res.data;
          this.seriesDays2[0].data = res.data.list.map((x) => {
            return x.count;
          });
          this.chartDaysOptions2.xaxis.categories = res.data.list.map((x) => {
            return x.dayText;
          });
          this.chartDaysOptionsKey2++;
          this.restrictedDaysData2.rdy = true;
        }
      });
    },
    loadTovchood() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhEnteredToUbVehicles" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.tovchoods = res.data.list1;
        }
      });
    },
  },
};
</script>
